export default __webpack_public_path__ + "static/media/hero.102c96dd.svg";